/**
 * Text of the error alert the quote modal shows above the form when Save Quote is pressed
 * without a quote name. Read by `QuoteModalDesktop.tsx` and `QuoteModalMobile.tsx`; the rest of
 * the modal's text is in `QuoteModalContent.ts`.
 */
import { LanguageContent } from "@ryerson/frontend.common";

interface QuoteModalLanguage {
    errorMessage: string;
}

/** The alert text per language (en, fr, es). */
export const withLanguage: LanguageContent<QuoteModalLanguage> = {
    en: {
        errorMessage: "Please review the highlighted fields and make any necessary changes."
    },
    fr: {
        errorMessage: "Veuillez vérifier les champs surlignés et apporter les modifications nécessaires."
    },
    es: {
        errorMessage: "Revise los campos resaltados y haga los cambios necesarios."
    }
};